import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import { useIntl } from '@/intl'
import { useBookingDetailsStore } from '@/scopes/account/booking-details/infrastructure/useBookingDetailsStore'
import { SpecialLuggageForm } from './SpecialLuggageForm'

export function SpecialLuggageSheet() {
  const { formatMessage } = useIntl()
  const isOpen = useBookingDetailsStore(state => state.specialLuggage.isOpen)
  const setIn = useBookingDetailsStore(state => state.setIn)

  return (
    <Sheet.Root open={isOpen} onOpenChange={open => setIn('specialLuggage.isOpen', open)}>
      <Sheet.Body side="right">
        <Sheet.Header
          closeLabel={formatMessage({ id: 'close' })}
          titleLabel={formatMessage({ id: 'booking_details_special_luggage_sheet_title' })}
        />
        <Sheet.Content>
          <SpecialLuggageForm />
        </Sheet.Content>
      </Sheet.Body>
    </Sheet.Root>
  )
}
